import { createSelector } from 'reselect';
import { FileUploadStatus } from '../enums';
import { getFileInfoState } from './getFileInfoState';
export const getUploadsInProgressCount = createSelector([getFileInfoState], state => {
    let inProgressUploadCount = 0;
    for (let index = 0; index < state.allIds.length; index++) {
        const fileInfo = state.byId[state.allIds[index]];
        if (fileInfo.uploadStatus === FileUploadStatus.IN_PROGRESS) {
            inProgressUploadCount++;
        }
    }
    return inProgressUploadCount;
});
//# sourceMappingURL=getUploadsInProgressCount.js.map